import React from 'react';

import Navbar from 'widgets/Navbar';

import 'styles/root.scss';
import Footer from 'widgets/Footer';

function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

export default Layout;
